import React from "react";
import PropTypes from "prop-types";
import * as types from "../../constants/ComponentConstants";
import Tooltip from "./Tooltip";

const Section = (props) => {
	let sectionclassName = props.color ? "c-section ia c-section--" + props.color : "c-section ia";
	sectionclassName = props.disabled ? sectionclassName + " disabled" : sectionclassName;
	const style = props.style || {};
	const classNames = props.classNames? props.classNames: "";

	const tooltip = props.tooltip
		? <Tooltip
			text={props.tooltip}
			tooltipType={types.TOOLTIP_INFO}
			windowWidth={props.tooltipWindowWidth}
			windowAlignRight={props.tooltipWindowAlignRight}
			tooltipColor={props.tooltipColor}
			iconColor={props.iconColor}
		/>
		: null;

	const header = props.title ? (
		<header className="c-section__header">
			<h1 className="l-section__title">{props.title}{tooltip}</h1>
		</header>) : null;

	return (
		<div className={`c-section-wrap  l-container--with-default-spacing ${classNames}`} style={style}>
			<div className="sb-styles:padding sb-layouts:section">
				<section className="l-section ">
					{header}
					<div className="l-section__content ">
						{props.children}
					</div>
				</section>
			</div>
		</div>
	);
};

Section.propTypes = {
	iconColor: PropTypes.string,
	title: PropTypes.string,
	style: PropTypes.object,
	color: PropTypes.string,
	children: PropTypes.node,
	disabled: PropTypes.bool,
	tooltipColor: PropTypes.string,
	tooltip: PropTypes.string,
	tooltipWindowWidth: PropTypes.number,
	tooltipWindowAlignRight: PropTypes.bool
};

export default Section;
